export const asFn = objOrGetter => typeof objOrGetter === 'function' ? objOrGetter : (...__args) => objOrGetter;